import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';

const cache = new Map();

/**
 * Erzeugt eindeutige Query-Parameter für Strapi-Filter.
 */
function createQueryParams(filters, endpoint) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    const keys = key.split('.');
    if (keys.length > 1) {
      params.append(`filters[${keys[0]}][${keys[1]}][$eq]`, value);
    } else if (typeof value === 'object') {
      Object.entries(value).forEach(([operator, val]) => {
        params.append(`filters[${key}][${operator}]`, val);
      });
    } else {
      params.append(`filters[${key}][$eq]`, value);
    }
  });

  const populate = getPopulateParams(endpoint);
  Object.entries(populate).forEach(([key, value]) => {
    params.append(key, value);
  });

  return params;
}

/**
 * Gibt die populate-Einstellungen je nach Endpoint zurück.
 */
function getPopulateParams(endpoint) {
  if (endpoint === 'button-pages') {
    return {
      'populate[TextfeldMittig_GrafikRechts][populate]': 'Grafik',
      'populate[BlauerPlanet][populate]': 'Grafik',
      'populate[Grafiken][populate]': 'EinzelneGrafik.Grafik',
      'populate[TextfeldMittig][populate]': '*',
      'populate[Video][populate]': 'Video',
      'populate[MehrereBilder][populate]': 'Bilder',
      'populate[Kartenzoom][populate]': 'ZoomAnimation',
      'populate[DeutschlandAethiopien][populate]': 'Laendergrafik.Grafik',
    };
  }
  return { populate: '*' };
}

export function useData({ endpoint, filters = {}, formatter = d => d }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const filtersRef = useRef(filters);

  useEffect(() => {
    if (JSON.stringify(filtersRef.current) !== JSON.stringify(filters)) {
      filtersRef.current = filters;
    }
  }, [filters]);

  useEffect(() => {
    const controller = new AbortController();
    const params = createQueryParams(filtersRef.current, endpoint);
    const url = `${API_URL}/${endpoint}?${params.toString()}`;
    const cacheKey = `${endpoint}?${params.toString()}`;

    async function fetchData() {
      if (cache.has(cacheKey)) {
        setData(cache.get(cacheKey));
        return;
      }

      try {
        const response = await axios.get(url, { signal: controller.signal });
        if (!response?.data?.data) throw new Error('Unerwartete API-Antwort');

        const formatted = formatter(response.data.data);
        cache.set(cacheKey, formatted);
        setData(formatted);
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error('Datenabruf-Fehler:', err);
          setError(`Fehler beim Laden von ${endpoint}`);
        }
      }
    }

    fetchData();
    return () => controller.abort();
  }, [endpoint, formatter]);

  return { data, error };
}